const ShopByCategorySection = (props) => {
  const {
    list = []
  } = props;
  const parsedList = list.map(each =>
    <li 
    key={each.id}
    class="ss-list-option ng-scope">
      <a href={"/categories/"+ encodeURIComponent(each.name?.toLowerCase()?.replaceAll(' ', '-'))} class="ss-list-link ng-binding">{each.name}</a>
    </li>
  )
  return (
      parsedList
  );
}

export default ShopByCategorySection;